export { default as rootReducer } from "./root-reducer";
export { default as rootEpic } from "./root-epic";

export { default } from "./store";
